import { InjectionToken } from '@angular/core';
import 'whatwg-fetch';
import { loadEnvironmentSuccessAction } from './environment.actions';
import { environmentReducer, State } from './environment.reducer';
import { getBaseUrl } from './environment.util';
import { FrontendEnvironment } from './environment.model';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { frontendEnvironment } from './environment.selectors';
import { first } from 'rxjs/operators';
import { AppState } from '../../../../apps/int-client/src/app/shared/store/app-state.model';

export const ENVIRONMENT_CONFIG = new InjectionToken('environmentConfig');

export enum ClientType {
	Web = 'web',
	Ios = 'ios',
}

export function loadEnvironment(url?: string, clientId: ClientType = ClientType.Web): Promise<FrontendEnvironment> {
	const envUrl = url ? url : `${getBaseUrl()}api/environment`;
	const headers = new Headers({
		'X-Client': clientId,
	});

	return window
		.fetch(envUrl, { headers })
		.then(response => response.json())
		.then(env => {
			window['__env__'] = env;
			return env;
		});
}

export function getEnvironmentFactory(): any {
	return window['__env__'];
}

export function frontendEnvironmentFactory(store: Store<AppState>): Observable<FrontendEnvironment> {
	return store.select(<any>frontendEnvironment).pipe(first());
}

export function getEnvironmentInitialState(): State {
	return environmentReducer(undefined, loadEnvironmentSuccessAction({ environment: getEnvironmentFactory() }));
}
